// /v3/analytics/network/:stationId/plays?userId=203825
import { DateRange } from '../../../Date/types';
import { getApiUrl } from '../../../Url';

const QUERY_KIND = 'plays';

export type NetworkPlaysParameters = DateRange & {
  webStationId: string;
  userId: number;
  timeInterval?: number;
};

export type NetworkPlaysResponse = {
  stationId: number;
  kind: 'plays';
  parameters: {
    timeRange: number[];
    timeInterval: number;
  };
  data: {
    rows: [number, number][];
  };
  columnHeader: [
    {
      name: 'Time (UTC)';
      type: 'integer';
    },
    { name: 'Plays'; type: 'integer' }
  ];
};

export async function fetchNetworkPlays({
  webStationId,
  userId,
  startDateRange,
  endDateRange,
  timeInterval,
}: NetworkPlaysParameters): Promise<NetworkPlaysResponse> {
  try {
    const response = await fetch(
      getNetworkPlaysUrl({
        webStationId,
        userId,
        startDateRange,
        endDateRange,
        timeInterval,
      }),
      {
        method: 'GET',
        credentials: 'same-origin',
      }
    );
    if (response.ok) {
      return await response.json();
    }
    throw new Error(`Could not fetch this network's total plays`);
  } catch (err) {
    throw new Error(err.message);
  }
}

export function getNetworkPlaysUrl({
  webStationId,
  userId,
  startDateRange,
  endDateRange,
  timeInterval,
  csvFilename,
}: NetworkPlaysParameters & {
  csvFilename?: string;
}) {
  return getApiUrl({
    path: `analytics/network/:webStationId:${webStationId}/${QUERY_KIND}`,
    queryParameters: {
      userId,
      startDateRange,
      endDateRange,
      timeInterval,
      csvFilename,
    },
  });
}
